module.exports = __webpack_public_path__ + "static/media/magnifying-glass-icon__red.d21c193f.svg";